export const prodFunctionsBaseUrl =
  "https://us-central1-neurosity-device.cloudfunctions.net";
